import type React from "react";

interface DashboardShellProps {
  children: React.ReactNode;
}

export function DashboardShell({ children }: DashboardShellProps) {
  return (
    <div className="container flex flex-col justify-center items-center gap-4 py-6 md:gap-8">
      {children}
    </div>
  );
}
